module.exports = __webpack_public_path__ + "media/assets/img/company/logo openclassroom-787aee8f3851254266a06d3ff79e1adb.png";